import React, { ReactNode } from 'react'

type ThemeTableProps = {
  labels: (string | ReactNode)[]
  children: ReactNode
  className?: string
  isBordered?: boolean
  align?: string
  headClass?: string
  thClass?: string | ((index: number) => string)
}

const ThemeTable = ({
  labels,
  children,
  className,
  isBordered = true,
  headClass = '',
  thClass = ''
}: ThemeTableProps) => {
  return (
    <div
      className={`mb-4 sm:mx-0 overflow-x-auto ${isBordered && 'sm:border'}  sm:border-tabBorder sm:rounded-xl rounded-none ${className}`}
    >
      <table
        className={`${isBordered && 'border'} w-full border-collapse border-none text-center whitespace-nowrap theme-table`}
      >
        <thead className={headClass}>
          <tr>
            {labels.map((element: ThemeTableProps['labels']['0'], index: number) => {
              const thClassName = typeof thClass === 'function' ? thClass(index) : thClass
              return (
                <th key={index} className={`${thClassName} text-xs md:text-base`}>
                  {element}
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  )
}

export default ThemeTable
